<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="700" persistent>
      <v-card>
        <v-card-text>
          <p class="text-primary text-center pt-4 mb-0">
            <b>NOTA:</b> Esta funcion permite cambiar el estado del postgrado,
          </p>
          <p class="text-primary text-center pt-0">
            <b>solo la directora academica nacional debe hacer este cambio.</b>
          </p>
          <v-divider />

          <p style="margin-bottom: 2px"><b>ID:</b> {{ prog.id }}</p>
          <p style="margin-bottom: 2px"><b>Postgrado:</b> {{ prog.nombre }}</p>
          <p><b>Fase actual:</b> {{ getFase }}</p>
          <div class="form-group">
            <p class="mb-1">
              La fase debe ir de forma consecutiva: <b>0</b> -> <b>1</b> -> <b>2</b> -> <b>3</b> -> <b>0</b>
            </p>
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Fase Nueva:</div>
              <select v-model.trim="fase" class="form-control">
                <option value="0">0. Por aprobar</option>
                <option value="1">1. Aprobado</option>
                <option value="2">2. Permitir crear programa</option>
                <option value="3">3. No permitir crear programa</option>
              </select>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" :disabled="loading" outlined @click="enviar()"> Cambiar estado </v-btn>
          <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import gql from 'graphql-tag';

  export default {
    data() {
      return {
        loading: true,
        dialog: false,
        fase: -1,
        prog: {},
      };
    },
    computed: {
      getFase() {
        const fase = this.prog.status;
        if (fase == 0) return '0 POR APROBAR';
        else if (fase == 1) return '1 APROBADO';
        else if (fase == 2) return '2 PERMITIR CREAR PROGRAMA';
        else if (fase == 3) return '3 NO PERMITIR CREAR PROGRAMA';
        else return 'Desconocido: ' + fase;
      },
    },
    methods: {
      async openmodal(xitem) {
        window.console.log('xitem', xitem);
        this.msg = '';
        this.prog = xitem;
        this.fase = this.prog.status;
        this.loading = false;

        const perm = this.permiso();
        if (!perm) {
          this.$root.$notify.show(`No dispone de los privilegios necesarios para realizar esta modificación.`, {
            color: 'red',
            x: 'right',
          });
          this.dialog = false;
        } else {
          this.dialog = true;
        }
      },
      cerrar() {
        this.dialog = false;
      },
      permiso() {
        let isdevmode = false;
        const apidev = process.env.VUE_APP_GRAPHQL;
        if (apidev.includes('apidev')) {
          isdevmode = true;
        }
        if (isdevmode) {
          this.$root.$notify.show(`Autorizado en modo pruebas`, { color: 'purple', x: 'right' });
          return true;
        }

        let negocioid = this.$store.state.CARGO.sede.unidad_negocio;
        let sedeid = this.$store.state.CARGO.sede.id;
        if (negocioid == 1) {
          let userid = this.$store.state.DATA_USER.id;
          // 73 marcia para programas esam dbs ...
          let perm = userid == 95 || userid == 35886 || userid == 59716 || userid == 73;

          if (perm) return true;
          else return false;
        } else if (negocioid == 10) {
          let userid = this.$store.state.DATA_USER.id;
          let perm =
            userid == -43 || userid == 8017 || userid == 73 || userid == 864 || userid == 35886 || userid == 59716;
          if (perm) return true;
          else return false;
        } else if (negocioid == 12) {
          let userid = this.$store.state.DATA_USER.id;
          let carg = this.$store.state.CARGO.id;
          let perm = userid == 46812 || userid == 25174;
          if (perm || carg == 6) return true;
          else return false;
        } else if (negocioid == 14) {
          // ispi
          let userid = this.$store.state.DATA_USER.id;
          let carg = this.$store.state.CARGO.id;
          let ispaula_upi = sedeid == 121 && userid == 12988;
          let perm = userid == 12988 || userid == 104802;
          if (perm || carg == -6 || ispaula_upi) return true;
          else return false;
        } else if (negocioid == 15) {
          // upi
          /*
          ID: 65958	5153434	Claudia	Escobar	Salguero
          ID: 76447	10384039	Clarice	Romero	Ordoñez
          PAULA TAMBIEN PUEDE POR QUE APRUEBA DE SU SEDE PERO  POR DEFECTO SE LISTA TODOS LOS POSTGRADOS DE LA UNIDAD
          ASI QUE NI MODO SOLO QUEDA CONFIAR EN SU BUENA FE QUE SOLO APROBARARA PARA SU SEDE.
          */
          let userid = this.$store.state.DATA_USER.id;
          let ispaula_upi = sedeid == 121 && userid == 12988;
          let perm = userid == 65958 || userid == 76447 || userid == -43;

          if (perm || ispaula_upi) return true;
          else return false;
        } else if (negocioid == 2) {
          // cca
          let userid = this.$store.state.DATA_USER.id;
          let perm = userid == 95 || userid == 35886 || userid == 113600 || userid == 59716;
          if (perm) return true;
          else return false;
        }
        return true;
      },
      async enviar() {
        this.loading = true;
        let sql = gql`mutation{ cambiarPostgradoStatus(input:{id:${this.prog.id},status:${this.fase}}){ok,errors{message}} }`;

        const res = await this.$apollo
          .mutate({ mutation: sql })
          .then(({ data }) => data)
          .catch((error) => error);
        this.loading = false;
        window.console.log('ressss', res);
        if (res && res.cambiarPostgradoStatus) {
          const ok = res.cambiarPostgradoStatus.ok;
          if (ok) {
            this.prog.status = this.fase;
            this.$root.$notify.show(`Fase cambiada`, { color: 'green', x: 'right' });
          } 
          else {
            let errores = res.cambiarPostgradoStatus.errors;
            let vals = '';
            errores.forEach(function (e) {
              vals += e.message + '. \n\t';
            });
            this.$root.$notify.show(vals, { color: 'red', x: 'right' });
          }
        }
      },
    },
  };
</script>
